module.exports = __webpack_public_path__ + "static/media/ideas_loading.690617f6.png";